export default "__VITE_ASSET__DOotgzD3__"